export const arrayToObject = (
  arr: Object[],
  key = 'id',
  mapFunction: Function = (obj: Object): Object => obj,
): Object =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  arr.reduce((accumulator: any, obj: any): Object => {
    if (obj[key]) {
      return {
        ...accumulator,
        [obj[key]]: mapFunction(obj, accumulator[obj[key]]),
      };
    }

    return accumulator;
  }, {});

export const sortSkills = (skillsObj: Object) => {
  return Object.entries(skillsObj).map(([key, value]: any) => {
    const keyItem = key?.split('~');
    const skill = keyItem.length === 2 ? keyItem[0] : keyItem[0]?.replace("_experience", "");
    const id = keyItem?.[1]?.replace("_experience", "");
    return {
      skill,
      value,
      id,
    };         
  }).sort((a: any, b: any) => a.id - b.id);
};
